module.exports = __webpack_public_path__ + "img/edge_activites_vtt_descente.d424e866.svg";